/**
 * TinyMCE 按需加载（npm 打包），并在全局挂载供 @tinymce/tinymce-react 使用。
 * 必须在首次使用 Editor 组件前执行一次 import。
 */
import tinymce from 'tinymce/tinymce';
import 'tinymce/models/dom/model';
import 'tinymce/themes/silver';
import 'tinymce/icons/default';

import 'tinymce/plugins/autolink';
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/link';
import 'tinymce/plugins/image';
import 'tinymce/plugins/table';
import 'tinymce/plugins/code';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/codesample';
import 'tinymce/plugins/save';
import 'tinymce/plugins/importcss';

import 'tinymce/skins/ui/oxide/skin.min.css';
import 'tinymce/skins/content/default/content.min.css';

if (typeof window !== 'undefined') {
    window.tinymce = tinymce;
}

export default tinymce;
